/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssessmentAiModel } from './AssessmentAiModel';
import {
  AssessmentAiModelFromJSON,
  AssessmentAiModelFromJSONTyped,
  AssessmentAiModelToJSON,
} from './AssessmentAiModel';
import type { AssessmentQuestionnaireAnswer } from './AssessmentQuestionnaireAnswer';
import {
  AssessmentQuestionnaireAnswerFromJSON,
  AssessmentQuestionnaireAnswerFromJSONTyped,
  AssessmentQuestionnaireAnswerToJSON,
} from './AssessmentQuestionnaireAnswer';
import type { RiskIndicator } from './RiskIndicator';
import { RiskIndicatorFromJSON, RiskIndicatorFromJSONTyped, RiskIndicatorToJSON } from './RiskIndicator';
import type { RiskMetric } from './RiskMetric';
import { RiskMetricFromJSON, RiskMetricFromJSONTyped, RiskMetricToJSON } from './RiskMetric';
import type { DatasetPipelineShallow } from './DatasetPipelineShallow';
import {
  DatasetPipelineShallowFromJSON,
  DatasetPipelineShallowFromJSONTyped,
  DatasetPipelineShallowToJSON,
} from './DatasetPipelineShallow';

/**
 * Representation of assessment including status, runtime, progress and Risk Indicator when
 * assessment is complete
 * @export
 * @interface AssessmentDetail
 */
export interface AssessmentDetail {
  /**
   *
   * @type {number}
   * @memberof AssessmentDetail
   */
  readonly id: number;
  /**
   *
   * @type {AssessmentQuestionnaireAnswer}
   * @memberof AssessmentDetail
   */
  readonly questionnaireAnswer: AssessmentQuestionnaireAnswer;
  /**
   *
   * @type {Array<RiskMetric>}
   * @memberof AssessmentDetail
   */
  readonly riskMetrics: Array<RiskMetric>;
  /**
   *
   * @type {boolean}
   * @memberof AssessmentDetail
   */
  quick?: boolean;
  /**
   *
   * @type {RiskIndicator}
   * @memberof AssessmentDetail
   */
  readonly riskIndicator: RiskIndicator;
  /**
   * The timestamp when the assessment was created.
   * @type {Date}
   * @memberof AssessmentDetail
   */
  readonly timestamp: Date;
  /**
   * The current status of the assessment.
   * @type {string}
   * @memberof AssessmentDetail
   */
  readonly status: string;
  /**
   * The current progress of the assessment.
   * @type {number}
   * @memberof AssessmentDetail
   */
  readonly progress: number;
  /**
   * The start time of the assessment.
   * @type {Date}
   * @memberof AssessmentDetail
   */
  readonly startTime: Date | null;
  /**
   * The end time of the assessment.
   * @type {Date}
   * @memberof AssessmentDetail
   */
  readonly endTime: Date | null;
  /**
   * The estimated time for the assessment to complete.
   * @type {string}
   * @memberof AssessmentDetail
   */
  readonly estimatedTime: string;
  /**
   *
   * @type {string}
   * @memberof AssessmentDetail
   */
  readonly user: string;
  /**
   *
   * @type {string}
   * @memberof AssessmentDetail
   */
  comment?: string;
  /**
   * The elapsed time since the assessment started.
   * @type {string}
   * @memberof AssessmentDetail
   */
  readonly elapsedTime: string;
  /**
   * The AI model associated with the questionnaire answer.
   * @type {AssessmentAiModel}
   * @memberof AssessmentDetail
   */
  readonly aiModel: AssessmentAiModel;
  /**
   *
   * @type {DatasetPipelineShallow}
   * @memberof AssessmentDetail
   */
  readonly datasetPipeline: DatasetPipelineShallow;
  /**
   *
   * @type {string}
   * @memberof AssessmentDetail
   */
  readonly reportType: string;
}

/**
 * Check if a given object implements the AssessmentDetail interface.
 */
export function instanceOfAssessmentDetail(value: object): value is AssessmentDetail {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('questionnaireAnswer' in value) || value['questionnaireAnswer'] === undefined) return false;
  if (!('riskMetrics' in value) || value['riskMetrics'] === undefined) return false;
  if (!('riskIndicator' in value) || value['riskIndicator'] === undefined) return false;
  if (!('timestamp' in value) || value['timestamp'] === undefined) return false;
  if (!('status' in value) || value['status'] === undefined) return false;
  if (!('progress' in value) || value['progress'] === undefined) return false;
  if (!('startTime' in value) || value['startTime'] === undefined) return false;
  if (!('endTime' in value) || value['endTime'] === undefined) return false;
  if (!('estimatedTime' in value) || value['estimatedTime'] === undefined) return false;
  if (!('user' in value) || value['user'] === undefined) return false;
  if (!('elapsedTime' in value) || value['elapsedTime'] === undefined) return false;
  if (!('aiModel' in value) || value['aiModel'] === undefined) return false;
  if (!('datasetPipeline' in value) || value['datasetPipeline'] === undefined) return false;
  if (!('reportType' in value) || value['reportType'] === undefined) return false;
  return true;
}

export function AssessmentDetailFromJSON(json: any): AssessmentDetail {
  return AssessmentDetailFromJSONTyped(json, false);
}

export function AssessmentDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssessmentDetail {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    questionnaireAnswer: AssessmentQuestionnaireAnswerFromJSON(json['questionnaire_answer']),
    riskMetrics: (json['risk_metrics'] as Array<any>).map(RiskMetricFromJSON),
    quick: json['quick'] == null ? undefined : json['quick'],
    riskIndicator: RiskIndicatorFromJSON(json['risk_indicator']),
    timestamp: new Date(json['timestamp']),
    status: json['status'],
    progress: json['progress'],
    startTime: json['start_time'] == null ? null : new Date(json['start_time']),
    endTime: json['end_time'] == null ? null : new Date(json['end_time']),
    estimatedTime: json['estimated_time'],
    user: json['user'],
    comment: json['comment'] == null ? undefined : json['comment'],
    elapsedTime: json['elapsed_time'],
    aiModel: AssessmentAiModelFromJSON(json['ai_model']),
    datasetPipeline: DatasetPipelineShallowFromJSON(json['dataset_pipeline']),
    reportType: json['report_type'],
  };
}

export function AssessmentDetailToJSON(
  value?: Omit<
    AssessmentDetail,
    | 'id'
    | 'questionnaireAnswer'
    | 'riskMetrics'
    | 'riskIndicator'
    | 'timestamp'
    | 'status'
    | 'progress'
    | 'startTime'
    | 'endTime'
    | 'estimatedTime'
    | 'user'
    | 'elapsedTime'
    | 'aiModel'
    | 'datasetPipeline'
    | 'reportType'
  > | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    quick: value['quick'],
    comment: value['comment'],
  };
}
